const makeInitialState = () => {
  return {
    motive: ''
  };
};

export default makeInitialState;
